// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, objectOf, tupleOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementSurveyQuestionChartResult = objectOf({
  question_id: string,
  question_type: string,
  total_responses: number,
  data: arrayOf(tupleOf(string, anyOf(string, number))),
});
